import React from "react";
import markUrl from "../assets/brand/quantiv-mark.svg";
import wordmarkInk from "../assets/brand/quantiv-logo.png";
import wordmarkWhite from "../assets/brand/quantiv-logo-white.png";

/**
 * Quantiv Media brand mark.
 *  - `variant="full"`   → wordmark + tagline (default)
 *  - `variant="lockup"` → wordmark only
 *  - `variant="mark"`   → just the Q tile
 *
 * These are the real asset files from quantivmedia.com, not a redraw. The
 * previous component hand-drew the Design Fundaz mark in SVG with hardcoded
 * colours, which is why it never picked up a theme.
 *
 * Two wordmark files exist because the artwork has baked-in ink: quantiv-logo
 * is dark ink for light surfaces, quantiv-logo-white is white ink for dark
 * ones. `mono` forces the white file (used on the dark login/invite panels);
 * otherwise both render and CSS in index.css shows whichever matches the
 * current theme, so there is no flash on load and no JS state to keep in sync.
 *
 * `size` is the rendered HEIGHT in px; the artwork is 1200x376, so width
 * follows at roughly 3.2x. The old `size` meant the square mark's edge, so
 * existing call sites land at a very similar visual weight.
 */
export default function BrandLogo({ variant = "full", size = 44, mono = false }) {
  if (variant === "mark") {
    return (
      <img
        src={markUrl}
        alt=""
        aria-hidden="true"
        width={size}
        height={size}
        style={{ display: "block", flexShrink: 0, borderRadius: size * 0.19 }}
      />
    );
  }

  const img = (src, className) => (
    <img
      src={src}
      alt="Quantiv Media"
      className={className}
      style={{ height: size, width: "auto", display: "block", flexShrink: 0 }}
    />
  );

  return (
    <div style={{ display: "inline-flex", flexDirection: "column", gap: 3, lineHeight: 1, userSelect: "none" }}>
      {mono
        ? img(wordmarkWhite)
        : (
          <>
            {img(wordmarkInk, "brand-wordmark-light")}
            {img(wordmarkWhite, "brand-wordmark-dark")}
          </>
        )}
      {variant === "full" && (
        <span
          style={{
            fontFamily: "'Familjen Grotesk', 'Montserrat', sans-serif",
            fontWeight: 600,
            fontSize: Math.max(9, size * 0.18),
            letterSpacing: "0.18em",
            color: mono ? "currentColor" : "var(--text-tertiary)",
            textTransform: "uppercase",
          }}
        >
          Demand &amp; Discovery, Engineered
        </span>
      )}
    </div>
  );
}
